import mutations from './mutations'
import actions from './actions'

const state = {
  isAgree:false
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/huaweiVIP/store/index.js